<template>
  <div class="modal-mask animate__animated overflow-scroll">
    <div
      ref="modalShareRef"
      class="modal-share modal-template animate__animated animate__fadeInDown md:h-screen"
      :class="{ 'no-social': !socialMedia }"
    >
      <header class="flex">
        <h1 v-if="socialMedia" class="share-title">
          {{ $t("wegow.profile.sections.events.share") }}
        </h1>
        <h1 v-else class="share-title">
          {{ $t("wegow.purchase.addCalendar") }}
        </h1>
        <img
          class="cursor-pointer"
          :src="require('@/assets/images/modal-cross.png')"
          style="height: 15px; width: 15px;"
          @click="$emit('close')"
        />
      </header>
      <div v-if="socialMedia" class="share-logos">
        <img
          :src="require('@/assets/images/ic-copylink-topaz.svg')"
          :alt="$t('magazine.links.copyLink')"
          @click="getUrl()"
        />

        <img
          :src="require('@/assets/images/ic-whatsapp-topaz.svg')"
          :alt="$t('general.brandLogo', { brand: 'WhatsApp' })"
          @click="getWtsa('https://wa.me/?text=')"
        />
        <img
          :src="require('@/assets/images/ic-telegram-topaz.svg')"
          :alt="$t('general.brandLogo', { brand: 'Telegram' })"
          @click="getWtsa('https://t.me/share?url=')"
        />
        <!-- <img
        :src="require('@/assets/images/ic-comment-topaz.svg')"
        alt=""
      /> -->
      </div>
      <calendar-btns
        v-else
        @active-google-calendar="$emit('activeGoogleCalendar')"
        @active-outlook-calendar="$emit('activeOutlookCalendar')"
      />
      <p v-if="successLink" class="copied-successful">
        <span
          ><img
            :src="require('@/assets/images/ic-checked-topaz.svg')"
            :alt="$t('magazine.links.copySuccess')"/></span
        >{{ $t("magazine.links.copySuccess") }}
      </p>
    </div>
  </div>
</template>

<script setup>
import useDetectOutsideClick from "@/plugins/useDetectOutsideClick";
import { onBeforeUnmount, onMounted, ref } from "vue";
import CalendarBtns from "@/components/general/ui/elements/CalendarBtns.vue";
const props = defineProps({
  category: {
    type: String,
    default: ""
  },
  routeSlug: {
    type: String,
    default: ""
  },
  xPosition: {
    type: String,
    default: "calc(70% - 345px)"
  },
  yPosition: {
    type: String,
    default: "5%"
  },
  socialMedia: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits([
  "close",
  "activeGoogleCalendar",
  "activeOutlookCalendar"
]);
const successLink = ref(false);
const modalShareRef = ref();
const canClose = ref(false);

onMounted(() => {
  window.addEventListener("keydown", closeDialog);
  setTimeout(() => {
    canClose.value = true;
  }, 250);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", closeDialog);
  canClose.value = false;
});

const closeDialog = () => {
  emit("close");
};

const getUrl = async () => {
  const textarea = document.createElement("textarea");
  textarea.value = props.routeSlug
    ? `${location.origin}/${props.routeSlug}`
    : location.href;
  textarea.style.position = "fixed";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  successLink.value = true;
  setTimeout(() => {
    successLink.value = false;
    closeDialog();
  }, 1500);
};
const getWtsa = url => {
  const message = encodeURIComponent(
    props.routeSlug ? `${location.origin}/${props.routeSlug}` : location.href
  );
  window.open(url + message);
  setTimeout(() => {
    closeDialog();
  }, 1500);
};

useDetectOutsideClick(modalShareRef, () => {
  if (canClose.value) {
    emit("close");
  }
});
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.modal-share {
  width: 690px;
  height: 338px;
  margin: auto;
  background-color: $backgroundBlack;
  opacity: 0.8;
  border-radius: 5px;
  z-index: 20;
  animation: fadeInDown 0.5s ease;
  @media screen and (max-width: $screen-xl) {
    width: 90%;
    top: 20vh;

    .share-logos {
      padding: 0 60px !important;
      img {
        width: 45px !important;
        height: 45px !important;
      }
    }
  }
  header {
    align-items: unset;
    padding: 19px 19px 0 0;
    h1 {
      padding-top: 63px;
      color: white;
    }
    .share-title {
      font-size: 2rem;
      font-weight: 400;
      margin: auto;
      margin-bottom: 55px;
    }
  }
  &.no-social {
    height: 275px;
    .share-title {
      margin-bottom: 44px;
    }
    h1 {
      padding-top: 43px;
    }
  }

  .share-logos {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 0 110px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .copied-successful {
    display: flex;
    justify-content: center;
    margin-top: 2.6rem;
    color: $topaz;
    span {
      margin-right: 6px;
      img {
        margin: auto;
      }
    }
  }
}
</style>
